/* @flow */
export type Location = {
  pathname: string,
  search?: string,
  hash?: string,
};

export type LocationAction = Location & {
  action: string,
};

/**
 * Used to create actions for react-router
 * @param {string} pathname
 * @param {string} search
 * @param {string} hash
 */
export const pushLocationAction = ({ pathname, search = '', hash = '' }: Location): LocationAction => ({
  pathname,
  search,
  hash,
  action: 'PUSH',
});
